import api from "../../../api.js";

// Mark prescription/payment/repeat as Returned
// payload: { prescriptionid: number, repeatid?: number }
export async function markReturned(payload) {
  const res = await api.post('/dispensary/returns/mark', payload);
  return res.data;
}
